import { useFormContext } from "react-hook-form";

import Checkbox from "Components/Admin/Form/Checkbox";

import * as S from "./styles";

const Checkboxes = ({
  label,
  items,
  selected,
  setSelected,
  columns = true,
}) => {
  const { setValue } = useFormContext();
  return (
    <S.Wrapper>
      <label>{label}</label>
      <S.Checkboxes columns={columns}>
        {items.map((item) => (
          <Checkbox
            name={item.name}
            key={item.name}
            label={item.label}
            defaultChecked={selected?.includes(item.name)}
            onClick={(e) => {
              setValue("checkbox", true, {
                shouldDirty: true,
              });
              e.stopPropagation();

              if (e.target.checked === undefined) return;

              if (e.target.checked) {
                setSelected((prev) => [...prev, item.name]);
              } else {
                setSelected((prev) => prev.filter((i) => i !== item.name));
              }
            }}
          />
        ))}
      </S.Checkboxes>
    </S.Wrapper>
  );
};

export default Checkboxes;
